import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import {
  DiscountMatchType,
  DiscountOptionModel,
} from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  discountFromModel,
  validateDiscountCondition,
  type DiscountState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const DISCOUNT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DiscountState>>,
): ConditionType<DiscountState, Condition.Discount> => ({
  name: CONDITION_NAMES[Condition.DISCOUNT],
  description(state) {
    return t("Discounts: {{codes}}", { codes: state.codes.join(", ") });
  },
  Details(props: ConditionTypeDetailsProps<DiscountState>) {
    return React.createElement(Details, props);
  },
  empty: {
    codes: [],
    codeOption: DiscountOptionModel.ITEM,
    matchType: DiscountMatchType.EXACT,
  },
  fromModel(model: Condition.Discount) {
    return discountFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.DISCOUNT,
      codes: state.codes,
      codeOption: state.codeOption,
      matchType: state.matchType || DiscountMatchType.EXACT,
    };
  },
  valid(state) {
    return validateDiscountCondition(state).valid;
  },
});
